import { ApolloClient, InMemoryCache, gql } from "@apollo/client";

const client = () =>
  new ApolloClient({
    uri: "https://api.thegraph.com/subgraphs/name/richdao2022/richcitygraph",
    cache: new InMemoryCache(),
  });

const apollo = queryString => {
  return client()
    .query({
      query: gql(queryString),
    })
    .then(data => {
      return data;
    })
    .catch(err => console.error("qraph ql error: ", err));
};

const extClient = uri =>
  new ApolloClient({
    uri: uri,
    cache: new InMemoryCache(),
  });

export const apolloExt = (queryString, uri) => {
  return extClient(uri)
    .query({
      query: gql(queryString),
    })
    .then(data => {
      return data;
    })
    .catch(err => console.error("external graph ql api error: ", err));
};

export default apollo;
